export const convertObjectKeysFromCamelCaseToKebabCase = (obj: { [key: string]: any }) => {
  const newObj: { [key: string]: any } = {};
  for (const key in obj) {
    if (obj.hasOwnProperty(key)) {
      const kebabCaseKey = key.replace(/([a-z])([A-Z])/g, '$1-$2').toLowerCase();
      newObj[kebabCaseKey] = obj[key];
    }
  }
  return newObj;
};
